import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Book } from 'bookraw/shared/models/book.model';
import { ItemResponse } from 'bookraw/shared/models/api/item.response';
import { environment } from 'env/environment';
import { ListResponse } from 'bookraw/shared/models/api/list.response';
import { HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class BooksService extends ListService<Book> {
  url: string = '/api/admin/books';

  appOpening(ssoId, bookId) {
    return this.http.get<ItemResponse<any>>(
      environment.baseURL +
        '/api/oauth/sso/appFromAdmin/' +
        bookId +
        '/login/' +
        ssoId
    );
  }

  saveBookOrder(order: number[]) {
    return this.http.post(
      environment.baseURL + '/api/admin/books/featuredOrder',
      { featuredBookIds: order }
    );
  }

  addFeaturedBooks(books: Book | Book[] ) {
    const featuredBookIds = Array.isArray(books) ? books.map(book => book.id) : [books.id];
    return this.http.post(
      environment.baseURL + '/api/admin/books/addFeatured',
      { featuredBookIds: featuredBookIds }
    );
  }

  addToPlaylist(bookId: number, playlistId: number ) {
    return this.http.post(
      environment.baseURL + `/api/admin/books/${bookId}/playlists/${playlistId}`,
      {}
    );
  }

  removeFeaturedBooks(books: Book | Book[] ) {
    const featuredBookIds = Array.isArray(books) ? books.map(book => book.id) : [books.id];
    return this.http.post(
      environment.baseURL + '/api/admin/books/removeFeatured',
      { featuredBookIds: featuredBookIds }
    );
  }

  getWords() {
    return this.http.get<ListResponse<string>>(environment.baseURL + this.url + '/words' + this.queryParams.paramString );
  }

  exportWords( title: string, words: string[]) {
    const params = new HttpParams({
      fromObject: { 'title': title, 'words[]': words },
    });

    const headers = new HttpHeaders().set('Accept', 'application/pdf');
    return this.http.get(environment.baseURL + this.url + '/exportWords' + this.queryParams.paramString, {
      headers, observe: 'response', params: params, responseType: 'blob'
    });
  }
}
